import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-custom-pagination',
  templateUrl: './custom-pagination.component.html',
  styleUrls: ['./custom-pagination.component.css'],
  standalone: false,
})
export class CustomPaginationComponent {
  @Input() page: number | string = '1';
  @Input() totalPage: number | string = '10';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() newPage = new EventEmitter<any>();

  pageChang(item: string | number) {
    if (Number(item) < 1 || Number(item) > Number(this.totalPage)) return;
    if (typeof item === 'string' || typeof item === 'number') {
      this.page = item;
    }
    this.newPage.emit(item.toString());
  }

  counter(i: number | string) {
    const result = Array.from({length: Number(i)}, (_, index) => index + 1);
    return result;
  }
}
